import { render, staticRenderFns } from "./DisplayList.vue?vue&type=template&id=8bd2328c&scoped=true"
import script from "./DisplayList.vue?vue&type=script&lang=js"
export * from "./DisplayList.vue?vue&type=script&lang=js"
import style0 from "./DisplayList.vue?vue&type=style&index=0&id=8bd2328c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd2328c",
  null
  
)

export default component.exports